export { default } from "./ListHistoricoVentasDia";
